import Vue from "vue";
//全局配置请求信息
Vue.prototype.baseURL = "https://courseapi.tongshike.cn";
Vue.prototype.baseURL1 = "https://apps.tongshike.cn";
Vue.prototype.rescourceURL = "https://leicloud.ulearning.cn/";
Vue.prototype.pathURL = "http://d.tongshike.cn";
Vue.prototype.docsURL = "https://docs.ulearning.cn";
Vue.prototype.domain = "";
// Vue.prototype.SCREEN_DOMAIN = 'http://swt.tongshike.cn/#/';
if (location.hostname.indexOf(".tongshike.cn") != -1) {
  Vue.prototype.domain = ".tongshike.cn";
} else if (location.hostname.indexOf(".ulearning.cn") != -1) {
  Vue.prototype.baseURL = "https://courseapi.ulearning.cn";
  Vue.prototype.baseURL1 = "https://apps.ulearning.cn";
  Vue.prototype.rescourceURL = "https://leicloud.ulearning.cn/";
  Vue.prototype.pathURL = "http://d.ulearning.cn";
  Vue.prototype.domain = ".ulearning.cn";
} else if (location.hostname.indexOf("ulearning") != -1) {
  var i18nHost = location.hostname.substring(location.hostname.indexOf("."));

  Vue.prototype.baseURL = "https://courseapi" + i18nHost;
  Vue.prototype.baseURL1 = "https://apps" + i18nHost;
  Vue.prototype.rescourceURL = "https://leicloud.ulearning.cn/";
  Vue.prototype.pathURL = "http://d" + i18nHost;
  Vue.prototype.docsURL = "http://docs" + i18nHost;
  Vue.prototype.domain = i18nHost;
}

// if(common.getCookie('Authorization')){
//     axios.defaults.headers.common['Authorization'] = common.getCookie('Authorization');
// }



// WEBPACK FOOTER //
// ./src/common/js/plugIn.js